import { useCallback, useState } from 'react';

import { useOpenClose } from '~/core/hooks/useOpenClose';
import { ConfirmDialogOptions } from '../../types/ConfirmDialogOptions';
import { UseConfirmDialogReturn } from '../../types/useConfirmDialogReturn';

export const useConfirmDialog = (): UseConfirmDialogReturn => {
  const [options, setOptions] = useState<ConfirmDialogOptions | null>(null);
  const { open, onClose, onOpen } = useOpenClose();

  const openConfirm = useCallback(
    (opts: ConfirmDialogOptions) => {
      setOptions(opts);
      onOpen();
    },
    [onOpen],
  );

  const closeConfirm = useCallback(() => {
    onClose();
    setOptions(null);
  }, [onClose]);

  const onConfirm = useCallback(async () => {
    if (options?.onConfirm) {
      await options.onConfirm();
    }
    closeConfirm();
  }, [options, closeConfirm]);

  return {
    open,
    options,
    onOpen: openConfirm,
    onClose: closeConfirm,
    onConfirm,
  };
};
